export default __webpack_public_path__ + "static/list-block-1-bg-tablet-ecd4b0dbc4ffa43395ec66247e649f0a.png";